<template>
  <div>
    <b-form-group
        label="Date début du trimestre"
        required="true">
      <b-form-select
          id="input-trimestres"
          v-model="trimestreId"
          :options="trimestres"
      >
        <template v-slot:first>
          <b-form-select-option :value="null">
            Sélectionner un trimestre
          </b-form-select-option>
        </template>
      </b-form-select>
      <div class="typo-warning" v-if="!isBeforeTrimestre() && trimestreIdFin != null">
        le trimestre de fin doit être postérieure à la trimestre de début
      </div>
    </b-form-group>
    <b-form-group
        label="Date fin du trimestre">
      <b-form-select
          id="input-trimestres"
          v-model="trimestreIdFin"
          :options="trimestres"
      >
        <template v-slot:first>
          <b-form-select-option :value="null">
            Sélectionner un trimestre
          </b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>
    <b-row class="pt-2" align-h="center">
      <b-button v-if="isBeforeTrimestre() || (trimestreId !=null && trimestreIdFin ==null)" type="button" variant="primary" @click="exporter">
        Valider l'export
      </b-button>
    </b-row>
  </div>
</template>

<script>
import ReportingStore from "@/stores/ReportingStore";
import FileUtil from "@/utils/fileUtil";
import AlertStore from "@/stores/AlertStore";
import ExportReportingTrimestrielDto from "@/dtos/ExportReportingTrimestrielDto";

export default {
  name: "ReportingChoixDateTrimestriel",
  props: {
    trimestres: {}
  },
  data() {
    return {
      trimestreId: null,
      trimestreIdFin: null
    }
  },
  mounted() {
  },
  methods: {
    exporter() {
      if (this.trimestreId) {
        const reporting = this.createReportingRecherche();
        ReportingStore.export(reporting, false).then(
            result => {
              FileUtil.downloadFile(result.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf8;');
            },
            error => AlertStore.pushError(error.response.data.message)
        );
      }
    },
    createReportingRecherche() {
      const reporting = new ExportReportingTrimestrielDto();
      reporting.trimestreId = this.trimestreId;
      reporting.trimestreIdFin = this.trimestreIdFin;
      return reporting;
    },
    isBeforeTrimestre() {
      if (this.trimestreId && this.trimestreIdFin) {
        if(this.trimestreId <= this.trimestreIdFin) {
          return true;
        }
      }
      return false;
    }
  }
}
</script>

<style scoped>

</style>